<script setup lang="ts">
import ChatMessage from './ChatMessage.vue';
import { createMessage } from '../messages';
import { ref } from 'vue';

const message = createMessage('assistant', 'Placeholder text', false);

const disclaimerContent = window.chatConfig?.disclaimer || '<p>Es ist kein Datenschutz-Hinweis hinterlegt.</p>';
const disclaimer = disclaimerContent.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

const consent = ref(false);

const emit = defineEmits<{
    consent: [];
}>();

const giveConsent = () => {
    consent.value = true;
    emit('consent');
};
</script>

<template>
    <ChatMessage :message :allowFeedback="false">
        <template #bubble>
            <div class="chat-message__content chat-message__content--disclaimer" v-html="disclaimer"></div>
            <button v-if="!consent" class="btn btn-primary mt-3" @click="giveConsent">Zustimmen und Chat starten</button>
        </template>
    </ChatMessage>
</template>
